var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellinvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.65723L7.66641 8.40723C7.55822 8.48837 7.42664 8.53223 7.29141 8.53223H2.5V5.40723C2.5 5.24147 2.56585 5.0825 2.68306 4.96528C2.80027 4.84807 2.95924 4.78223 3.125 4.78223H7.29141C7.42664 4.78223 7.55822 4.82609 7.66641 4.90723L10 6.65723Z",
    fill: "black",
    fillOpacity: 0.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 6.03223H10.2086L8.04141 4.40723C7.82472 4.24555 7.56176 4.1579 7.29141 4.15723H3.125C2.79348 4.15723 2.47554 4.28892 2.24112 4.52334C2.0067 4.75776 1.875 5.07571 1.875 5.40723V16.0322C1.875 16.3637 2.0067 16.6817 2.24112 16.9161C2.47554 17.1505 2.79348 17.2822 3.125 17.2822H16.875C17.2065 17.2822 17.5245 17.1505 17.7589 16.9161C17.9933 16.6817 18.125 16.3637 18.125 16.0322V7.28223C18.125 6.95071 17.9933 6.63276 17.7589 6.39834C17.5245 6.16392 17.2065 6.03223 16.875 6.03223ZM3.125 5.40723H7.29141L8.95859 6.65723L7.29141 7.90723H3.125V5.40723ZM16.875 16.0322H3.125V9.15723H7.29141C7.56176 9.15656 7.82472 9.0689 8.04141 8.90723L10.2086 7.28223H16.875V16.0322Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellinvoice);
export default __webpack_public_path__ + "static/media/sellinvoice.5d2236a68b83d847d1626e41db4dcd3b.svg";
export { ForwardRef as ReactComponent };